module.exports = __webpack_public_path__ + "static/media/ethereum-logo.802c6eac.svg";